import { iconsHome } from "../settings/index"

type IconsHomeProps = {
  header: JSX.Element | undefined,
  footer: JSX.Element | undefined,
}

export function IconsHomeCustom({ header, footer }: IconsHomeProps) {

  const itemIcon = (item: any) => {
    if (item.href != '') {
      return (
        <a href={`${item.href}`} id='icon-one' className="iconsHome__card">
          <div className="iconsHome__topArea">
            <div className="iconsHome__icon">
              <img src={item.icon}></img>
            </div>
          </div>
          <div className="iconsHome__bottomArea">
            <div className="iconsHome__name">
              <h5>{item.title}</h5>
              <p>{item.subtitle}</p>
            </div>
          </div>
        </a>
      )
    }
    if (item.href == '') {
      return (
        <div id='icon-one' className="iconsHome__card">
          <div className="iconsHome__topArea">
            <div className="iconsHome__icon">
              <img src={item.icon}></img>
            </div>
          </div>
          <div className="iconsHome__bottomArea">
            <div className="iconsHome__name">
              <h5>{item.title}</h5>
              <p>{item.subtitle}</p>
            </div>
          </div>
        </div>
      )
    }
  }

  const icons = iconsHome.items.map(item => itemIcon(item))
  return (
    <section className='iconsHome'>
      <div className="iconsHome__container">
        {header ? header :
          <>
            <div className="iconsHome__title">
              <h3>{iconsHome.h3}</h3>
            </div>
          </>
        }
        <div className={`iconsHome__grid grid xl:grid-cols-${iconsHome.items.length} lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 gap-4`}>
          {icons}
        </div>
        {footer && footer}
      </div>
    </section>
  );
};